"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinsComponentLoader = void 0;
var _react = _interopRequireDefault(require("react"));
var _sharedComponents = require("@site/shared-components");
var _uxUtils = require("@site/ux-utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const SpinsComponentLoader = ({
  showBorder = false
}) => {
  const {
    isTablet,
    isDesktop,
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const mapper = new Array(4).fill(0);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-skeleton-loader"
  }, mapper.map((el, index) => /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-skeleton-loader",
    className: (0, _classnames.default)('d-flex justify-content-between spins-skeleton-loader', {
      'bd-t-1 bd-gray': showBorder
    }),
    key: index
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "d-flex mx-2",
    height: "2.5rem",
    width: "45%"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: (0, _classnames.default)('d-flex my-3', {
      'mr-1': isTablet,
      'mr-4': isDesktop,
      'mr-2': isMobile
    }),
    height: "5rem",
    width: isDesktop || isTablet ? '7%' : '20%'
  }))));
};
exports.SpinsComponentLoader = SpinsComponentLoader;
SpinsComponentLoader.propTypes = {
  showBorder: _propTypes.default.bool
};